import React from 'react';
import lichtspektakel1 from '../../assets/img/projects/lichtspektakel1.jpg'
import lichtspektakel2 from '../../assets/img/projects/lichtspektakel2.jpg'
import lichtspektakel3 from '../../assets/img/projects/lichtspektakel3.jpg'
import lichtspektakel4 from '../../assets/img/projects/lichtspektakel4.jpg'

const Lichtspektakel = () =>
{
    console.log('rendered');
    return(
        <div>
           <Text/>
            <img className="Project-Content"
                // onClick={() => this.openSketch()}
                src={ lichtspektakel1 }
                alt="lichtspektakel1"
            />
             <img className="Project-Content"
                // onClick={() => this.openSketch()}
                src={ lichtspektakel2 }
                alt="lichtspektakel2"
            />
             <img className="Project-Content"
                // onClick={() => this.openSketch()}
                src={ lichtspektakel3 }
                alt="lichtspektakel3"
            />
             <img className="Project-Content"
                // onClick={() => this.openSketch()}
                src={ lichtspektakel4 }
                alt="lichtspektakel4"
            />
            <br></br>
            <br></br>
        </div>
    );
}

export default Lichtspektakel;

const Text = () =>
{
    return(
        <div className="Project-Content">
            GLSL shaders used for projection mapping on the Brandenburg Gate in Potsdam for Lichtspektakel 2019.
            <br></br>
            <br></br>
            
        </div>
    );
}